export default __webpack_public_path__ + "images/excel.png";